// The div in App.tsx where scrollable content is loaded has id main_for_scrolling
// Call this function at first render to scroll to top
export const scrollTop = () => {
  const mainForScrolling = document.getElementById('main_for_scrolling')
  if (mainForScrolling) {
    mainForScrolling.scrollTo(0, 0);
  }
}